module.exports = __webpack_public_path__ + "static/img/ANAB-transparent.8e72d5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/ANAB-transparent.png
// module id = 165
// module chunks = 4